export default "__VITE_ASSET__BcBkL9Hm__"